interface VideoConfig {
  type: "mux" | "youtube";
  videoId: string;
  thumbnailTime?: number;
}

interface VideosConfig {
  [key: string]: VideoConfig;
}

const videos: VideosConfig = {
  groupsAndMonitoring: {
    type: "mux",
    videoId: "uasgc7PMiXCKgCaeTtg2SveZ3cv9F7aqB5kE2fQoByc",
  },
  calendarsAndPrograms: {
    type: "mux",
    videoId: "LmZMJKEpOWUF6w46QqK4IhEifYZI8FubVwVcWbddwrs",
    thumbnailTime: 8,
  },
  lvpWalkthrough: {
    type: "mux",
    videoId: "lef01zndcBHgr6vGdIXa2bBdn53ghGu7S02sYGG9qUb1Q",
  },
} as const;

export default videos;
